// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".reviewTab[data-v-121a4ea7] {\n  width: calc(100% - 393px);\n}\n", ""]);
// Exports
module.exports = exports;
